import T from '@wojtekmaj/react-t';

import { Image, ImageContainer, Text, Wave, WaveMask, Wrapper } from './slide.styles';

type SlideProps = {
  backgroundColor: string;
  current: number;
  fetchPriority?: 'high' | 'low' | 'auto';
  image: string;
  imageWebp?: string;
  imageAvif?: string;
  text: string;
  total: number;
};

export default function Slide({
  backgroundColor,
  current,
  fetchPriority,
  image,
  imageWebp,
  imageAvif,
  text,
  total,
}: SlideProps) {
  return (
    <Wrapper>
      <ImageContainer>
        <picture>
          <source srcSet={imageAvif} type="image/avif" />
          <source srcSet={imageWebp} type="image/webp" />
          <source srcSet={image} type="image/png" />
          <Image alt="" src={image} width={375} height={404} fetchPriority={fetchPriority} />
        </picture>
      </ImageContainer>
      <Wave current={current} total={total} />
      <WaveMask backgroundColor={backgroundColor} current={current} total={total} />
      <Text>
        <T>{text}</T>
      </Text>
    </Wrapper>
  );
}
